



























































































import { Component, Vue } from "vue-property-decorator";
import {
  ImportacaoService,
  ValidaProduto,
} from "@/services/importacao.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Loading from "@/shared/components/loading.vue";
import { moeda, dateTime } from "@/shared/filters";
import FileUpload from "@/shared/components/file-upload.vue";
import AlterarPrecoProduto from "./alterarPrecoProduto.vue";

@Component({
  components: { DataTable, Tooltip, Loading, FileUpload, AlterarPrecoProduto },
  filters: { moeda, dateTime },
})
export default class Importacao extends Vue {
  file: File | null = null;
  promise: Promise<ValidaProduto[]> | null = null;
  apenasInvalidos = true;
  headers = [
    { value: "produto.codigo", text: "Código" },
    { value: "produto.nome", text: "Nome" },
    { value: "produto.valorPromocional", text: "Valor Promocional" },
    { value: "produto.valorUnitario", text: "Valor Unitário" },
    { value: "validoAte", text: "Válido Até" },
    { value: "historicoParaAlterar", text: "Historico" },
    { value: "actions", text: "Ações", sortable: false },
  ];
  async processar() {
    if (this.file) {
      this.promise = ImportacaoService.validarProdutos(
        this.$route.params.idCatalogo,
        this.file
      );
    }
  }
  classFilter(item: ValidaProduto) {
    if (item.inexistente) {
      return "red--text";
    }
  }
  async alterarHistorico(id: string) {
    this.promise?.then((array) => {
      array.splice(
        array.findIndex((x) => x.historicoParaAlterar == id),
        1
      );
      this.promise = new Promise((resolve) => {
        resolve(array);
      });
    });
    await ImportacaoService.estenderHistorico(id);
  }
  validarItem(item: ValidaProduto) {
    item.invalido = false;
  }

  async alterarPreco(item: ValidaProduto) {
    const modal = this.$refs.alterarPrecoProduto as AlterarPrecoProduto;
    modal.abrir(item);
  }

  filterApenasInvalidos(
    value: any,
    apenasInvalidos: string,
    item: ValidaProduto
  ) {
    return apenasInvalidos == "true" ? item.invalido : true;
  }

  formatarNome(texto: string): string {
    if (!texto) return '';
    
    return texto.toLowerCase().replace(/(?:^|\s)\S/g, letra => letra.toUpperCase());
  }
}
